import { DRAWER_TYPES } from '@/constants/drawer.js';

import store from '@/store/index';

export default class Drawer {
  constructor() {
    this.store = store;
  }

  get subdrawer() {
    return this.store.getters.subdrawer;
  }

  subdrawerSet(type) {
    this.store.dispatch('setSubdrawerType', type);
  }

  subdrawerHide() {
    this.store.dispatch('setSubdrawerType', null);
  }

  subdrawerShow() {
    this.store.dispatch('setSubdrawerType', DRAWER_TYPES.portal);
  }

  subdrawerToggle() {
    if (this.subdrawer) this.subdrawerHide();
    else this.subdrawerShow();
  }
}
